var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "path3349",
    transform: "matrix(0.867449,0,0,0.867449,3.90691,1.9115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.266,29.154L7.789,25.832L6.624,25.805L1.061,25.805L4.927,1.292C4.939,1.218 4.978,1.149 5.035,1.1C5.092,1.051 5.165,1.024 5.241,1.024L14.621,1.024C17.735,1.024 19.884,1.672 21.006,2.951C21.532,3.551 21.867,4.178 22.029,4.868C22.199,5.592 22.202,6.457 22.036,7.512L22.024,7.589L22.024,8.265L22.55,8.563C22.993,8.798 23.345,9.067 23.615,9.375C24.065,9.888 24.356,10.54 24.479,11.313C24.606,12.108 24.564,13.054 24.356,14.125C24.116,15.357 23.728,16.43 23.204,17.308C22.722,18.117 22.108,18.788 21.379,19.308C20.683,19.802 19.856,20.177 18.921,20.417C18.015,20.653 16.982,20.772 15.849,20.772L15.119,20.772C14.597,20.772 14.09,20.96 13.692,21.297C13.293,21.641 13.029,22.111 12.948,22.625L12.893,22.924L11.969,28.779L11.927,28.994C11.916,29.062 11.897,29.096 11.869,29.119C11.844,29.14 11.808,29.154 11.773,29.154L7.266,29.154Z",
    style: {
      fill: "rgb(37,59,128)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3351",
    transform: "matrix(0.867449,0,0,0.867449,3.90691,1.9115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.048,7.667C23.02,7.846 22.988,8.029 22.952,8.217C21.715,14.568 17.483,16.762 12.078,16.762L9.326,16.762C8.665,16.762 8.108,17.242 8.005,17.894L6.596,26.83L6.197,29.363C6.13,29.791 6.46,30.177 6.892,30.177L11.773,30.177C12.351,30.177 12.842,29.757 12.933,29.187L12.981,28.939L13.9,23.107L13.959,22.787C14.049,22.215 14.541,21.795 15.119,21.795L15.849,21.795C20.578,21.795 24.28,19.875 25.362,14.319C25.814,11.998 25.58,10.06 24.384,8.697C24.022,8.286 23.573,7.945 23.048,7.667Z",
    style: {
      fill: "rgb(23,155,215)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3353",
    transform: "matrix(0.867449,0,0,0.867449,3.90691,1.9115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.754,7.151C21.565,7.096 21.37,7.046 21.17,7.001C20.969,6.957 20.763,6.918 20.551,6.884C19.809,6.764 18.996,6.707 18.125,6.707L10.773,6.707C10.592,6.707 10.42,6.748 10.266,6.822C9.927,6.985 9.675,7.306 9.614,7.699L8.05,17.605L8.005,17.894C8.108,17.242 8.665,16.762 9.326,16.762L12.078,16.762C17.483,16.762 21.715,14.567 22.952,8.217C22.989,8.029 23.02,7.846 23.048,7.667C22.735,7.501 22.396,7.359 22.031,7.238C21.941,7.208 21.848,7.179 21.754,7.151Z",
    style: {
      fill: "rgb(34,45,101)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3355",
    transform: "matrix(0.867449,0,0,0.867449,3.90691,1.9115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.614,7.699C9.675,7.306 9.927,6.985 10.266,6.823C10.421,6.749 10.592,6.708 10.773,6.708L18.125,6.708C18.996,6.708 19.809,6.765 20.551,6.885C20.763,6.919 20.969,6.958 21.17,7.002C21.37,7.047 21.565,7.097 21.754,7.152C21.848,7.18 21.941,7.209 22.032,7.238C22.397,7.359 22.736,7.502 23.049,7.667C23.417,5.32 23.046,3.722 21.777,2.275C20.378,0.682 17.853,0 14.622,0L5.242,0C4.582,0 4.019,0.48 3.917,1.133L0.01,25.898C-0.067,26.388 0.311,26.83 0.805,26.83L6.596,26.83L8.05,17.605L9.614,7.699Z",
    style: {
      fill: "rgb(37,59,128)",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.f8c81e8e65f87845545d986cd0a48eea.svg";
export { ForwardRef as ReactComponent };